export default __webpack_public_path__ + "static/media/KingsViewMarket.f123fad7.jpg";